<template>
  <div class="product">
    <router-view></router-view>
  </div>
</template>

<script>
    export default {
        name: "product"
    }
</script>

